import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import icSearch from "@/assets/images/console/icSearch.svg";

import Input, { InputProps } from "./Input";

interface SearchInputProps extends InputProps {
    boxClassName?: string;
    handleClick?: () => void;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({ boxClassName, handleClick, ...props }, ref) => {
    return (
        <div className={twMerge("relative w-[320px]", boxClassName)}>
            <Input
                ref={ref}
                {...props}
                placeholder="검색어를 입력해주세요."
                className={twMerge("pr-[40px]", props.className)}
                onKeyDown={e => {
                    if (e.key === "Enter" && handleClick) {
                        e.preventDefault();
                        handleClick();
                    }
                }}
            />
            <button type="button" className="absolute right-0 top-0 h-full w-[40px]" onClick={handleClick}>
                <img src={icSearch} alt="검색하기" />
            </button>
        </div>
    );
});

SearchInput.displayName = "SearchInput";

export default SearchInput;
